export default __webpack_public_path__ + "static/media/figma.af82a6a2.svg";